export default "__VITE_ASSET__49e49668__"